function parseItem(str) {
  const idx = str.lastIndexOf("::");
  if (idx === -1) return { name: str, qty: 1 };
  return { name: str.slice(0, idx), qty: parseInt(str.slice(idx + 2)) || 1 };
}

export default function CategoryDetailModal({ cat, contributions, onClose }) {
  const itemDetails = cat.items
    .map(itemName => {
      const contributors = [];
      let total = 0;
      for (const c of contributions) {
        for (const rawItem of c.items || []) {
          const { name, qty } = parseItem(rawItem);
          if (name === itemName) {
            total += qty;
            contributors.push({ name: c.contributor_name, qty });
          }
        }
      }
      return { itemName, total, contributors };
    })
    .filter(d => d.total > 0)
    .sort((a, b) => b.total - a.total);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)",
        display: "flex", alignItems: "flex-end", justifyContent: "center",
        zIndex: 200, padding: 0,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "#111", borderTop: "1px solid #1e1e1e",
          borderRadius: "14px 14px 0 0", width: "100%", maxWidth: 720,
          padding: "24px 20px 40px", maxHeight: "80vh", overflowY: "auto",
        }}
      >
        <div style={{ width: 36, height: 4, background: "#2a2a2a", borderRadius: 2, margin: "0 auto 20px" }} />

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 24 }}>{cat.icon}</span>
            <span style={{ fontFamily: "var(--font-display)", fontSize: 20, color: "#fff", letterSpacing: 2 }}>
              {cat.label.toUpperCase()}
            </span>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none", border: "1px solid #2a2a2a", borderRadius: 6,
              color: "#555", cursor: "pointer", padding: "5px 10px", fontSize: 12,
              transition: "color 0.15s, border-color 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.color = "#aaa"; e.currentTarget.style.borderColor = "#555"; }}
            onMouseLeave={e => { e.currentTarget.style.color = "#555"; e.currentTarget.style.borderColor = "#2a2a2a"; }}
          >
            Cerrar
          </button>
        </div>

        {itemDetails.length === 0 ? (
          <p style={{ color: "#444", fontSize: 13, textAlign: "center", padding: "32px 0" }}>
            Nadie ha anotado nada en esta categoría.
          </p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {itemDetails.map(({ itemName, total, contributors }) => (
              <div key={itemName} style={{
                background: "#161616", border: "1px solid #1e1e1e",
                borderRadius: 8, padding: "12px 16px",
                display: "flex", alignItems: "flex-start", gap: 14,
              }}>
                <div style={{
                  fontFamily: "var(--font-display)", fontSize: 28, fontWeight: 900,
                  color: "#00e676", minWidth: 40, textAlign: "center", lineHeight: 1, paddingTop: 2,
                }}>
                  {total}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, color: "#fff", marginBottom: 6, fontWeight: 600 }}>{itemName}</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                    {contributors.map(({ name, qty }) => (
                      <span key={name} style={{
                        background: "#1e1e1e", border: "1px solid #2a2a2a",
                        borderRadius: 4, fontSize: 11, padding: "3px 8px", color: "#aaa",
                      }}>
                        {name}{qty > 1 && <span style={{ color: "#cc2200", fontWeight: 700 }}> ×{qty}</span>}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
